<template>
    <!-- 路由出口 -->
    <router-view />
</template>


<script>
export default {
  watch:{
    //监听路由，浏览器刷新（直接从路由对象中取出 选项卡数据，创建一个选项卡）
    $route(to,from){
      if(to.path !=='/login' && to.path!=='/'){
        let tab = {
          icon:to.meta.icon,
          name:to.name,
          title:to.meta.title
        }

        this.$store.commit('ADD_TABS',tab)
      }
    }
  }
}
</script>

<style>

html,body,#app{
  height:100%;
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-family: 'Microsoft Yahei';
  color:#000;
  text-align: left;
}
ul{ list-style-type: none; margin: 0; padding: 0;}
</style>

